import { jsxs as p, jsx as m } from "react/jsx-runtime";
import { Tooltip as t } from "../tooltip/index.mjs";
import { QuestionMarkIcon as f } from "../../icons/question-mark-icon.mjs";
import { twMerge as e } from "tailwind-merge";
const d = ({
  children: s,
  className: i,
  color: l = "blue",
  showHint: o = !0,
  ...r
}) => /* @__PURE__ */ p("div", { className: e("flex items-center gap-0.5", i), children: [
  s,
  o && /* @__PURE__ */ m(
    t,
    {
      mode: "click",
      ...r,
      className: e("focus-ring rounded-full"),
      popoverClassName: e("!max-w-[200px] sm:!max-w-[350px]", r.popoverClassName),
      wrapperClassName: "m-1",
      children: (a) => /* @__PURE__ */ m(
        f,
        {
          className: e(
            `group-focus-visible:fill-${l} h-[16px] w-[16px]`,
            a ? `fill-${l}` : "fill-fill-primary"
          )
        }
      )
    }
  )
] });
export {
  d as Hint
};
